<template>
	<div>
              <!-- <v-row class="bradcrumb">
        <router-link :to="{name: 'role-links' }" class="root">
            Dashboard
        </router-link> -->
        <!-- <router-link :to="{name: 'eps-admin-master-menu' }" class="root">
            Super Master
        </router-link> -->
        <!-- <span class="child">/ Subject Authority Appointment</span>
    </v-row><br /> -->
		<v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
			<span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
			<v-btn dark text @click="snackbar = false">Close</v-btn>
		</v-snackbar>
		<v-container fluid style="padding:0">
			<template>
				<v-card class="mx-auto main" max-width="auto" height="" outlined>
					<v-form ref="form">
						<div class="box">
							<v-row>
								<v-col xs="12" sm="12" lg="3" md="6" cols="12">
									<label class="bold">Program Type</label>
									<v-autocomplete
										:items="progt_list"
										item-value="id"
										item-text="name"
										v-model="selected_prog"
										@change="findprogtype()"
										:rules="[v => !!v || 'required']"
										outlined
										dense
										placeholder="Select Program Type"
										class="select"
									></v-autocomplete>
								</v-col>
								<v-col xs="12" sm="12" lg="3" md="6" cols="12">
									<label class="bold">Program </label>
									<v-autocomplete
										:items="progtype_list"
										item-value="id"
										item-text="name"
										outlined
										dense
										placeholder="Select Program"
										v-model="selected_prog_type"
										:rules="[v => !!v || 'required']"
										class="select"
									></v-autocomplete>
								</v-col>
								<v-col xs="12" sm="12" lg="3" md="6" cols="12">
									<label class="bold">Year</label>
									<v-autocomplete
										:items="year_list"
										item-value="id"
										item-text="name"
										outlined
										dense
										placeholder="Select Year"
										v-model="year_data"
										:rules="[v => !!v || 'required']"
										@change="findsubject()"
										class="select"
									></v-autocomplete>
								</v-col>
								<v-col xs="12" sm="12" lg="3" md="6" cols="12">
									<label class="bold">Subject</label>
									<v-autocomplete
										:items="sub_list"
										item-value="id"
										item-text="course"
										placeholder="Select Subject"
										outlined
										dense
										:rules="[v => !!v || 'required']"
										class="select"
										v-model="selected_subject"
									></v-autocomplete>
								</v-col>
							</v-row>
							<v-card-actions
								v-if="
									selected_prog && selected_prog_type && year_data && selected_subject
								"
								class="justify-center"
							>
								<v-btn @click="findsubjectauthority" class="mb-2 button btn"
									>Fetch</v-btn
								>
							</v-card-actions>
						</div>
					</v-form>
					<v-row style="padding:8px">
						<v-col lg="6">
                            <p class="authlevel" v-if="instructor_data">Previous Allocation Data</p>
							<div class="text-center card" v-if="this.instructor_data">
								<p class="h-text">Allocation Data</p>
								<div class="text-left" v-if="instructor_data.length > 0">
                                <v-col v-for="ins in this.instructor_data" style="padding:0;" :key="ins">
                                        <div v-if="ins.authority" class="chip">
											<p class="authlevel"> {{ins.authority}}</p>
											<p v-for="(name,index) in ins.data"
										style="padding:0;margin:0" :key="index">
                                                <span class="inst-info">{{ name.insname }}</span>
											<i
												style="font-size:25px;color:red;cursor: pointer;"
												class="mdi mdi-delete-circle"
												@click="deleteData(name)"
											></i>
                                                </p>
										</div>
									</v-col>
								</div>
                                <div v-else>
                                <span style="color:red">No appointment done for selected course!!</span>
                                </div>
							</div>
						</v-col>
						<v-col lg="6">
							<template v-if="authority_data != null">
                            <p class="authlevel">Appoint Authority</p>
								<v-card class="mx-auto card" outlined>
									<v-form ref="saveform">
                                        
										<v-simple-table>
											<template v-slot:default>
												<thead>
													<tr>
														<th>Name</th>
														<th></th>
														<th>Select Instructor</th>
													</tr>
												</thead>
												<tbody>
													<tr v-for="item in authority_data" :key="item.name">
														<td class="authlevel">{{ item.auth.name }}</td>
														<td></td>
														<td>
															<v-autocomplete
																:items="instructor_list"
																item-value="ins_id"
																item-text="ins_emp_code_name"
																label="Select Authority Person"
																multiple
																@change="updateEmployee($event, item.auth.id, item.auth.name)"
															/>
														</td>
													</tr>
												</tbody>
											</template>
										</v-simple-table>
									</v-form>
									<center>
										<v-btn @click="savesubjectauthority" class="mb-2 button">Save</v-btn>
									</center>
								</v-card>
							</template>
						</v-col>
					</v-row>
				</v-card>
			</template>
		</v-container>
	</div>
</template>


<script>
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    import axios from "axios";
    export default {
        data: () => ({
            snackbar_msg: "",
            dialog: false,
            snackbar: false,
            color: "",
            org: null,
            search: '',
            edit_btn_load: false,
            selected_prog: '',
            fetch_org_load: false,
            selected_prog_type: '',
            selected_subject: '',
            year_data: '',
            dialog: false,
            selected: '',
            selected_employee: '',
            instructor_data: null,

            //
            selected_employee: null,
            authlevelname: null,
            progt_list: null,
            progtype_list: null,
            year_list: null,
            sub_list: null,
            auth_levels: null,
            authority_data: null,
            instructor_list: null,
            course_auth_level: null,
            selected_emp: [],
            selected_a_e: [],

            headers: null,
            editedIndex: -1,
            editedItem: {
                prog_type: '',
                progtype_list: null,
                program: '',
                year: '',
                course: '',
            },
            defaultItem: {
                prog_type: '',
                program: '',
                year: '',
                course: '',
            },
        }),
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
            },
        },

        watch: {
            dialog(val) {
                val || this.close()
            },
        },

        methods: {
            deleteData(instObj){
                    const data = {
                    selected_prog: this.selected_prog,
                    selected_prog_type: this.selected_prog_type,
                    year_data: this.year_data,
                    selected_subject: this.selected_subject,
                    authLevel:instObj.authLevel,
                    insname:instObj.insname,
                    instId:instObj.instId
                };

                axios
                    .post("/SubjectAppointment/deleteSubjectAuthoriytData", data)
                    .then(res => {
                        this.lang_list = res.data.lang_list
                        this.showSnackbar("#4CAF50", res.data.msg)
                        this.findsubjectauthority()
                    })
                    .catch(error => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => {
                        this.edit_btn_load = false
                    });
                    this.selected_emp = []
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            editTemplate(au) {

                this.editedIndex = this.course_auth_level.indexOf(au)
                alert('hi' + this.editedIndex);
                this.editedItem = Object.assign({}, au)
                this.dialog = true
                console.log('dialog info', this.editedItem)
                alert('hi bye');
            },
            close() {
                this.dialog = false;
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1;
                }, 300);
            },
            updateEmployee(value, authorityid, authname) {
                var selecte_auth_emp = {
                    authname: '',
                    details: {
                        authid: '',
                        empid: ''
                    }
                };
                selecte_auth_emp.authname = authname
                selecte_auth_emp.details.authid = authorityid
                selecte_auth_emp.details.empid = value
                if (this.selected_emp.some(item => item.authname === authname)) {
                    var index = this.selected_emp.findIndex(item => item.authname === authname);
                    if (index > -1) {
                        this.selected_emp.splice(index, 1);
                    }
                }

                this.selected_emp.push(selecte_auth_emp);
                console.log(this.selected_emp)
                    //this.selected_emp.push(authorityid);
            },
            editItem(item) {
                console.log(item)
                this.edit_btn_load = true
                axios
                    .post("/adminMaster/editStudentAttribute", item)
                    .then(res => {
                        this.lang_list = res.data.lang_list
                        this.showSnackbar("#4CAF50", "Success")
                    })
                    .catch(error => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => {
                        this.edit_btn_load = false
                    });
            },
            findprogtype() {
                const data = {
                    selected_prog: this.selected_prog
                };
                axios
                    .post("/SubjectAppointment/fetchProgtype", data)
                    .then(res => {
                        window.console.log(res);
                        if (res.data.msg == "200") {
                            this.progtype_list = res.data.pt;
                            //this.orglist.name=res.data.org.name
                            document.getElementById("ptdiv").style.display = "block";
                            //this.domainpath=res.data.domainpath
                        } else {
                            this.message = res.data.msg;
                        }
                    })
                    .catch(error => {
                        window.console.log("error:" + error);
                    })
                    .finally(() => (this.fetch_org_load = false));
            },
            findsubject() {
                const data = {
                    selected_prog: this.selected_prog,
                    selected_prog_type: this.selected_prog_type,
                    year_data: this.year_data,
                };
                axios
                    .post("/SubjectAppointment/fetchSubjectData", data)
                    .then(res => {
                        window.console.log(res);
                        if (res.data.msg == "200") {
                            this.sub_list = res.data.sub;
                            this.instructor_data = res.data.instructor_data
                                //this.orglist.name=res.data.org.name
                            document.getElementById("subdiv").style.display = "block";
                            //this.domainpath=res.data.domainpath
                        } else {
                            this.message = res.data.msg;
                        }
                    })
                    .catch(error => {
                        window.console.log("error:" + error);
                    })
                    .finally(() => (this.fetch_org_load = false));
            },
            findsubjectauthority() {
                const data = {
                    selected_prog: this.selected_prog,
                    selected_prog_type: this.selected_prog_type,
                    year_data: this.year_data,
                    selected_subject: this.selected_subject
                };
                axios
                    .post("/SubjectAppointment/fetchSubjectAuthoriytData", data)
                    .then(res => {
                        window.console.log(res);
                        if (res.data.msg == "200") {
                            this.authority_data = res.data.auth_data;
                            this.selected_employee = res.data.auth_data,
                                this.instructor_data = res.data.prev_inst_data,
                                //this.orglist.name=res.data.org.name
                                //document.getElementById("subdiv").style.display = "block";
                                this.instructor_list = res.data.instructor_data
                        } else {
                            this.message = res.data.msg;
                        }
                    })
                    .catch(error => {
                        window.console.log("error:" + error);
                    })
                    .finally(() => (this.fetch_org_load = false));
                     this.$refs.saveform.reset()
            },
            savesubjectauthority() {
                const data = {
                    selected_prog: this.selected_prog,
                    selected_prog_type: this.selected_prog_type,
                    year_data: this.year_data,
                    selected_subject: this.selected_subject,
                    selected_emp: this.selected_emp,
                };
                console.log(this.selected_emp,'this.selected_emp');
                axios
                    .post("/SubjectAppointment/saveSubjectAuthoriytData", data)
                    .then(res => {
                        window.console.log(res);
                        if (res.data.msg == "200") {
                            //this.authority_data = res.data.auth_data;
                            //this.orglist.name=res.data.org.name
                            //document.getElementById("subdiv").style.display = "block";
                            //this.instructor_list=res.data.instructor_data
                            this.showSnackbar("#4CAF50", "Successfully Appointed Subject Authority");
                     this.$refs.saveform.reset()
                     this.findsubjectauthority()

                        } else {
                            this.message = res.data.msg;
                        }
                    })
                    .catch(error => {
                        window.console.log("error:" + error);
                    })
                    .finally(() => (this.fetch_org_load = false));
                    this.selected_emp= []
            },
            onload(){
                axios
                .post("/SubjectAppointment/test")
                .then(res => {
                    this.org = res.data.org_list
                    this.progt_list = res.data.porgtype_list
                    this.editedItem.progtype_list = res.data.porgtype_list
                    this.year_list = res.data.year_list
                    this.course_auth_level = res.data.course_auth_level_data
                    this.auth_levels = res.data.auth_levels
                    this.authlevelname = res.data.auth_levels
                    this.headers = res.data.headers
                        // this.dummyyearlist = res.data.year_list
                    console.log('prog_list', this.progt_list)
                        //this.showSnackbar("#4CAF50","Success")
                })
                .catch(error => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                })
                .finally(() => {

                });
            }
        },

        mounted() {
            this.onload()
        }
    };
</script>
<style scoped>
.box {
	background-color: #add8e630;
	margin: 8px;
	padding: 8px;
}

.select >>> .v-input__slot {
	background: white !important;
	border-color: hsla(190, 99%, 30%, 1) !important;
}

.main {
	border: 2px solid hsla(190, 99%, 30%, 1) !important;
}

.select >>> .v-select .dropdown-toggle {
	border: none;
}

.h-text {
	background-color: hsla(190, 99%, 30%, 1) !important;
	color: white;
	font-size: 20px;
	font-weight: normal;
	padding: 10px;
}

.card {
	border: 2px solid hsla(190, 99%, 30%, 1) !important;
    border-radius: 0px !important;
}

.v-data-table thead {
	background-color: hsla(190, 99%, 30%, 1) !important;
}
.v-data-table tbody tr td{
border: none !important;
}
.theme--light.v-data-table thead tr th {
	color: white;
	font-size: 20px;
	font-weight: normal;
}
.chip {
	border: 1px solid;
	margin: 15px;
	/* border-radius: 20px; */
	padding-left: 8px;
}
.authlevel {
	font-weight: bold;
	color: hsla(190, 99%, 30%, 1);
    margin: 0;
}
.inst-info {
	font-size: 15px;
    color: black;
}
</style>